import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, EmptyError, of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/lib/local-storage.service';
import * as EmployeeActions from '../actions/employee.actions';




@Injectable()
export class EmployeeEffects {

  loadEmployee$ = createEffect(() => {
    return this.actions$.pipe(

      ofType(EmployeeActions.loadEmployee),
      concatMap(() => {

        const userData = JSON.parse(JSON.stringify(this.localStorageService.getUserData()));

        if (userData == null) {
          return EMPTY; // todo: redirect to login
        }

        const { loggedInemployee } = userData;

        return of({}).pipe(
          map(data => {
            return EmployeeActions.loadEmployeeSuccess({ loggedInemployee });
          }),
          catchError(error => of(EmployeeActions.loadEmployeeFailure({ error }))))
      })
    );
  });

  constructor(
    private actions$: Actions,
    private localStorageService: LocalStorageService
  ) { }

}
